import capitalize from "lodash/capitalize";
import words from "lodash/words";
var NonBreaking;
(function(NonBreaking) {
    NonBreaking.space = "\u00A0";
    NonBreaking.hyphen = "\u2011";
})(NonBreaking || (NonBreaking = {}));
export var preventOrphanWords = function(input) {
    var hyphenedInput = input.replace(/-/g, NonBreaking.hyphen);
    var trimedInput = hyphenedInput.trim();
    var lastSpace = trimedInput.lastIndexOf(" ");
    if (lastSpace === -1) {
        return trimedInput;
    }
    return trimedInput.slice(0, lastSpace) + NonBreaking.space + trimedInput.slice(lastSpace + 1, trimedInput.length);
};
export var titleCaseWithSpecialCharacters = function(input) {
    return words(input, /[^, ]+/g).map(function(word) {
        return capitalize(word);
    }).join(" ");
};
export var trimToken = function(token) {
    var _afterSplit_;
    var afterSplit = token.split("_");
    if (afterSplit.length <= 1) {
        throw Error("trimToken: Invalid token format");
    }
    var _afterSplit__toUpperCase;
    return (_afterSplit__toUpperCase = (_afterSplit_ = afterSplit[1]) === null || _afterSplit_ === void 0 ? void 0 : _afterSplit_.toUpperCase()) !== null && _afterSplit__toUpperCase !== void 0 ? _afterSplit__toUpperCase : "";
};
